export enum AssetDimension {
  _description = "Asset._description",
  _apirCode = "Asset._apirCode",
  _choice = "Asset._choice",
  _cash = "Asset._cash",
}

export const AssetCube = <const>{
  // Measures

  // Dimensions
  _description: AssetDimension._description,
  _apirCode: AssetDimension._apirCode,
  _choice: AssetDimension._choice,
  _cash: AssetDimension._cash,
}

export enum AssetOwnedMeasure {
  _worth = "AssetOwned._worth",
  percentWorth = "AssetOwned.percentWorth",
}

export const AssetOwnedCube = <const>{
  // Measures
  _worth: AssetOwnedMeasure._worth,
  percentWorth: AssetOwnedMeasure.percentWorth,

  // Dimensions
}

export enum CampaignMeasure {
  total = "Campaign.total",
  runs = "Campaign.runs",
}

export enum CampaignDimension {
  eventDate = "Campaign.eventDate",
  campaignType = "Campaign.campaignType",
}

export const CampaignCube = <const>{
  // Measures
  total: CampaignMeasure.total,
  runs: CampaignMeasure.runs,

  // Dimensions
  eventDate: CampaignDimension.eventDate,
  campaignType: CampaignDimension.campaignType,
}

export enum ContactRequestedMeasure {
  countRequests = "ContactRequested.countRequests",
}

export enum ContactRequestedDimension {
  reason = "ContactRequested.reason",
}

export const ContactRequestedCube = <const>{
  // Measures
  countRequests: ContactRequestedMeasure.countRequests,

  // Dimensions
  reason: ContactRequestedDimension.reason,
}

export enum EmailCampaignFunnelMeasure {
  conversions = "EmailCampaignFunnel.conversions",
  conversionsPercent = "EmailCampaignFunnel.conversionsPercent",
}

export enum EmailCampaignFunnelDimension {
  time = "EmailCampaignFunnel.time",
  step = "EmailCampaignFunnel.step",
}

export const EmailCampaignFunnelCube = <const>{
  // Measures
  conversions: EmailCampaignFunnelMeasure.conversions,
  conversionsPercent: EmailCampaignFunnelMeasure.conversionsPercent,

  // Dimensions
  time: EmailCampaignFunnelDimension.time,
  step: EmailCampaignFunnelDimension.step,
}

export enum WelcomeCampaignFunnelMeasure {
  conversions = "WelcomeCampaignFunnel.conversions",
  conversionsPercent = "WelcomeCampaignFunnel.conversionsPercent",
}

export enum WelcomeCampaignFunnelDimension {
  time = "WelcomeCampaignFunnel.time",
  step = "WelcomeCampaignFunnel.step",
}

export const WelcomeCampaignFunnelCube = <const>{
  // Measures
  conversions: WelcomeCampaignFunnelMeasure.conversions,
  conversionsPercent: WelcomeCampaignFunnelMeasure.conversionsPercent,

  // Dimensions
  time: WelcomeCampaignFunnelDimension.time,
  step: WelcomeCampaignFunnelDimension.step,
}

export enum MemberDimension {
  expiredBeneficiaryNominated = "Member.expiredBeneficiaryNominated",
  gender = "Member.gender",
  addressState = "Member.addressState",
  _accountType = "Member._accountType",
  _occupationalRating = "Member._occupationalRating",
}

export const MemberCube = <const>{
  // Measures

  // Dimensions
  expiredBeneficiaryNominated: MemberDimension.expiredBeneficiaryNominated,
  gender: MemberDimension.gender,
  addressState: MemberDimension.addressState,
  _accountType: MemberDimension._accountType,
  _occupationalRating: MemberDimension._occupationalRating,
}

export enum MemberCategoryDimension {
  _name = "MemberCategory._name",
}

export const MemberCategoryCube = <const>{
  // Measures

  // Dimensions
  _name: MemberCategoryDimension._name,
}

export enum MemberSnapshotMeasure {
  countMembers = "MemberSnapshot.countMembers",
  averageAge = "MemberSnapshot.averageAge",
  _minAge = "MemberSnapshot._minAge",
  _maxAge = "MemberSnapshot._maxAge",
  totalAssetsOwned = "MemberSnapshot.totalAssetsOwned",
  averageTotalAssetsOwned = "MemberSnapshot.averageTotalAssetsOwned",
  averageSalary = "MemberSnapshot.averageSalary",
  averageLifeInsuranceCover = "MemberSnapshot.averageLifeInsuranceCover",
  averageInsurancePremium = "MemberSnapshot.averageInsurancePremium",
  averageAdministrationFeeAmount = "MemberSnapshot.averageAdministrationFeeAmount",
  averageInvestmentFeeAmount = "MemberSnapshot.averageInvestmentFeeAmount",
  _count_BeneficiaryNominationAssistantCompleted_True = "MemberSnapshot._count_BeneficiaryNominationAssistantCompleted_True",
  _count_SalarySacrificeContributions_True = "MemberSnapshot._count_SalarySacrificeContributions_True",
  _percent_SalarySacrificeContributions_True = "MemberSnapshot._percent_SalarySacrificeContributions_True",
  _count_AfterTaxContributions_True = "MemberSnapshot._count_AfterTaxContributions_True",
  _percent_AfterTaxContributions_True = "MemberSnapshot._percent_AfterTaxContributions_True",
  _count_EmailAddressProvided_True = "MemberSnapshot._count_EmailAddressProvided_True",
  _percent_EmailAddressProvided_True = "MemberSnapshot._percent_EmailAddressProvided_True",
  _count_MobileNumberProvided_True = "MemberSnapshot._count_MobileNumberProvided_True",
  _percent_MobileNumberProvided_True = "MemberSnapshot._percent_MobileNumberProvided_True",
  _count_SuperRollover_True = "MemberSnapshot._count_SuperRollover_True",
  _percent_SuperRollover_True = "MemberSnapshot._percent_SuperRollover_True",
  totalContributions = "MemberSnapshot.totalContributions",
  totalSalarySacrificeContributions = "MemberSnapshot.totalSalarySacrificeContributions",
  totalAfterTaxContributions = "MemberSnapshot.totalAfterTaxContributions",
  _count_InsuranceCoverAll_True = "MemberSnapshot._count_InsuranceCoverAll_True",
  _percent_InsuranceCoverAll_True = "MemberSnapshot._percent_InsuranceCoverAll_True",
  _count_InsuranceCoverLifeTpd_True = "MemberSnapshot._count_InsuranceCoverLifeTpd_True",
  _percent_InsuranceCoverLifeTpd_True = "MemberSnapshot._percent_InsuranceCoverLifeTpd_True",
  _count_InsuranceCoverSalaryContinuation_True = "MemberSnapshot._count_InsuranceCoverSalaryContinuation_True",
  _percent_InsuranceCoverSalaryContinuation_True = "MemberSnapshot._percent_InsuranceCoverSalaryContinuation_True",
  _count_InsuranceCoverNone_True = "MemberSnapshot._count_InsuranceCoverNone_True",
  _percent_InsuranceCoverNone_True = "MemberSnapshot._percent_InsuranceCoverNone_True",
  _count_NewMember_True = "MemberSnapshot._count_NewMember_True",
  _count_ExitedMember_True = "MemberSnapshot._count_ExitedMember_True",
  _exitedTotalAssetsOwned = "MemberSnapshot._exitedTotalAssetsOwned",
  _count_InvestmentChoice_True = "MemberSnapshot._count_InvestmentChoice_True",
  _percent_InvestmentChoice_True = "MemberSnapshot._percent_InvestmentChoice_True",
  _count_GenderMale_True = "MemberSnapshot._count_GenderMale_True",
  _percent_GenderMale_True = "MemberSnapshot._percent_GenderMale_True",
  _count_TaxFileNumberProvided_True = "MemberSnapshot._count_TaxFileNumberProvided_True",
  _percent_TaxFileNumberProvided_True = "MemberSnapshot._percent_TaxFileNumberProvided_True",
  _count_BalanceAboveComfortableRetirementStandard_True = "MemberSnapshot._count_BalanceAboveComfortableRetirementStandard_True",
}

export enum MemberSnapshotDimension {
  potentiallyInadequateLifeInsurance = "MemberSnapshot.potentiallyInadequateLifeInsurance",
  ageGroup = "MemberSnapshot.ageGroup",
  balanceCompare = "MemberSnapshot.balanceCompare",
  balanceGroup = "MemberSnapshot.balanceGroup",
  salaryGroup = "MemberSnapshot.salaryGroup",
  timeInPlan = "MemberSnapshot.timeInPlan",
  taxFileNumberProvided = "MemberSnapshot.taxFileNumberProvided",
  voluntaryContributionsType = "MemberSnapshot.voluntaryContributionsType",
  insuranceCoverType = "MemberSnapshot.insuranceCoverType",
  noLifeInsurance = "MemberSnapshot.noLifeInsurance",
  beneficiaryNominationType = "MemberSnapshot.beneficiaryNominationType",
  nonBindingToBindingBeneficiaryNominated = "MemberSnapshot.nonBindingToBindingBeneficiaryNominated",
  loggedInMember = "MemberSnapshot.loggedInMember",
  _newMemberNoLogin = "MemberSnapshot._newMemberNoLogin",
  consultationPerformed = "MemberSnapshot.consultationPerformed",
  contactRequested = "MemberSnapshot.contactRequested",
  beneficiaryNominationAssistantCompleted = "MemberSnapshot.beneficiaryNominationAssistantCompleted",
  beneficiaryNominationValidated = "MemberSnapshot.beneficiaryNominationValidated",
  insuranceIndicatorCompleted = "MemberSnapshot.insuranceIndicatorCompleted",
  riskProfileAssessmentCompleted = "MemberSnapshot.riskProfileAssessmentCompleted",
  projectionModellerCompleted = "MemberSnapshot.projectionModellerCompleted",
  contributionCalculatorCompleted = "MemberSnapshot.contributionCalculatorCompleted",
  ttrCalculatorCompleted = "MemberSnapshot.ttrCalculatorCompleted",
  digitalGuidanceDownloaded = "MemberSnapshot.digitalGuidanceDownloaded",
  newMember = "MemberSnapshot.newMember",
  exitedMember = "MemberSnapshot.exitedMember",
  _at = "MemberSnapshot._at",
  /** Keep this manually **/
  _atMonth = "MemberSnapshot._at.month",
  emailAddressProvided = "MemberSnapshot.emailAddressProvided",
  mobileNumberProvided = "MemberSnapshot.mobileNumberProvided",
  phoneNumberProvided = "MemberSnapshot.phoneNumberProvided",
  _validData = "MemberSnapshot._validData",
  riskProfileName = "MemberSnapshot.riskProfileName",
  withinSevenYearsOfPreservationAge = "MemberSnapshot.withinSevenYearsOfPreservationAge",
  withinSevenYearsOfRetirementAge = "MemberSnapshot.withinSevenYearsOfRetirementAge",
  aboveMinimumBalance = "MemberSnapshot.aboveMinimumBalance",
  approachingConcessionalCap = "MemberSnapshot.approachingConcessionalCap",
  approachingNonConcessionalCap = "MemberSnapshot.approachingNonConcessionalCap",
  investmentChoice = "MemberSnapshot.investmentChoice",
}

export const MemberSnapshotCube = <const>{
  // Measures
  countMembers: MemberSnapshotMeasure.countMembers,
  averageAge: MemberSnapshotMeasure.averageAge,
  _minAge: MemberSnapshotMeasure._minAge,
  _maxAge: MemberSnapshotMeasure._maxAge,
  totalAssetsOwned: MemberSnapshotMeasure.totalAssetsOwned,
  averageTotalAssetsOwned: MemberSnapshotMeasure.averageTotalAssetsOwned,
  averageSalary: MemberSnapshotMeasure.averageSalary,
  averageLifeInsuranceCover: MemberSnapshotMeasure.averageLifeInsuranceCover,
  averageInsurancePremium: MemberSnapshotMeasure.averageInsurancePremium,
  averageAdministrationFeeAmount: MemberSnapshotMeasure.averageAdministrationFeeAmount,
  averageInvestmentFeeAmount: MemberSnapshotMeasure.averageInvestmentFeeAmount,
  _count_BeneficiaryNominationAssistantCompleted_True:
    MemberSnapshotMeasure._count_BeneficiaryNominationAssistantCompleted_True,
  _count_SalarySacrificeContributions_True:
    MemberSnapshotMeasure._count_SalarySacrificeContributions_True,
  _percent_SalarySacrificeContributions_True:
    MemberSnapshotMeasure._percent_SalarySacrificeContributions_True,
  _count_AfterTaxContributions_True: MemberSnapshotMeasure._count_AfterTaxContributions_True,
  _percent_AfterTaxContributions_True: MemberSnapshotMeasure._percent_AfterTaxContributions_True,
  _count_EmailAddressProvided_True: MemberSnapshotMeasure._count_EmailAddressProvided_True,
  _percent_EmailAddressProvided_True: MemberSnapshotMeasure._percent_EmailAddressProvided_True,
  _count_MobileNumberProvided_True: MemberSnapshotMeasure._count_MobileNumberProvided_True,
  _percent_MobileNumberProvided_True: MemberSnapshotMeasure._percent_MobileNumberProvided_True,
  _count_SuperRollover_True: MemberSnapshotMeasure._count_SuperRollover_True,
  _percent_SuperRollover_True: MemberSnapshotMeasure._percent_SuperRollover_True,
  totalContributions: MemberSnapshotMeasure.totalContributions,
  totalSalarySacrificeContributions: MemberSnapshotMeasure.totalSalarySacrificeContributions,
  totalAfterTaxContributions: MemberSnapshotMeasure.totalAfterTaxContributions,
  _count_InsuranceCoverAll_True: MemberSnapshotMeasure._count_InsuranceCoverAll_True,
  _percent_InsuranceCoverAll_True: MemberSnapshotMeasure._percent_InsuranceCoverAll_True,
  _count_InsuranceCoverLifeTpd_True: MemberSnapshotMeasure._count_InsuranceCoverLifeTpd_True,
  _percent_InsuranceCoverLifeTpd_True: MemberSnapshotMeasure._percent_InsuranceCoverLifeTpd_True,
  _count_InsuranceCoverSalaryContinuation_True:
    MemberSnapshotMeasure._count_InsuranceCoverSalaryContinuation_True,
  _percent_InsuranceCoverSalaryContinuation_True:
    MemberSnapshotMeasure._percent_InsuranceCoverSalaryContinuation_True,
  _count_InsuranceCoverNone_True: MemberSnapshotMeasure._count_InsuranceCoverNone_True,
  _percent_InsuranceCoverNone_True: MemberSnapshotMeasure._percent_InsuranceCoverNone_True,
  _count_NewMember_True: MemberSnapshotMeasure._count_NewMember_True,
  _count_ExitedMember_True: MemberSnapshotMeasure._count_ExitedMember_True,
  _exitedTotalAssetsOwned: MemberSnapshotMeasure._exitedTotalAssetsOwned,
  _count_InvestmentChoice_True: MemberSnapshotMeasure._count_InvestmentChoice_True,
  _percent_InvestmentChoice_True: MemberSnapshotMeasure._percent_InvestmentChoice_True,
  _count_GenderMale_True: MemberSnapshotMeasure._count_GenderMale_True,
  _percent_GenderMale_True: MemberSnapshotMeasure._percent_GenderMale_True,
  _count_TaxFileNumberProvided_True: MemberSnapshotMeasure._count_TaxFileNumberProvided_True,
  _percent_TaxFileNumberProvided_True: MemberSnapshotMeasure._percent_TaxFileNumberProvided_True,
  _count_BalanceAboveComfortableRetirementStandard_True:
    MemberSnapshotMeasure._count_BalanceAboveComfortableRetirementStandard_True,

  // Dimensions
  potentiallyInadequateLifeInsurance: MemberSnapshotDimension.potentiallyInadequateLifeInsurance,
  ageGroup: MemberSnapshotDimension.ageGroup,
  balanceCompare: MemberSnapshotDimension.balanceCompare,
  balanceGroup: MemberSnapshotDimension.balanceGroup,
  salaryGroup: MemberSnapshotDimension.salaryGroup,
  timeInPlan: MemberSnapshotDimension.timeInPlan,
  taxFileNumberProvided: MemberSnapshotDimension.taxFileNumberProvided,
  voluntaryContributionsType: MemberSnapshotDimension.voluntaryContributionsType,
  insuranceCoverType: MemberSnapshotDimension.insuranceCoverType,
  noLifeInsurance: MemberSnapshotDimension.noLifeInsurance,
  beneficiaryNominationType: MemberSnapshotDimension.beneficiaryNominationType,
  nonBindingToBindingBeneficiaryNominated:
    MemberSnapshotDimension.nonBindingToBindingBeneficiaryNominated,
  loggedInMember: MemberSnapshotDimension.loggedInMember,
  _newMemberNoLogin: MemberSnapshotDimension._newMemberNoLogin,
  consultationPerformed: MemberSnapshotDimension.consultationPerformed,
  contactRequested: MemberSnapshotDimension.contactRequested,
  beneficiaryNominationAssistantCompleted:
    MemberSnapshotDimension.beneficiaryNominationAssistantCompleted,
  beneficiaryNominationValidated: MemberSnapshotDimension.beneficiaryNominationValidated,
  insuranceIndicatorCompleted: MemberSnapshotDimension.insuranceIndicatorCompleted,
  riskProfileAssessmentCompleted: MemberSnapshotDimension.riskProfileAssessmentCompleted,
  projectionModellerCompleted: MemberSnapshotDimension.projectionModellerCompleted,
  contributionCalculatorCompleted: MemberSnapshotDimension.contributionCalculatorCompleted,
  ttrCalculatorCompleted: MemberSnapshotDimension.ttrCalculatorCompleted,
  digitalGuidanceDownloaded: MemberSnapshotDimension.digitalGuidanceDownloaded,
  newMember: MemberSnapshotDimension.newMember,
  exitedMember: MemberSnapshotDimension.exitedMember,
  _at: MemberSnapshotDimension._at,
  /** Keep this manually **/
  _atMonth: MemberSnapshotDimension._atMonth,
  emailAddressProvided: MemberSnapshotDimension.emailAddressProvided,
  mobileNumberProvided: MemberSnapshotDimension.mobileNumberProvided,
  phoneNumberProvided: MemberSnapshotDimension.phoneNumberProvided,
  _validData: MemberSnapshotDimension._validData,
  riskProfileName: MemberSnapshotDimension.riskProfileName,
  withinSevenYearsOfPreservationAge: MemberSnapshotDimension.withinSevenYearsOfPreservationAge,
  withinSevenYearsOfRetirementAge: MemberSnapshotDimension.withinSevenYearsOfRetirementAge,
  aboveMinimumBalance: MemberSnapshotDimension.aboveMinimumBalance,
  approachingConcessionalCap: MemberSnapshotDimension.approachingConcessionalCap,
  approachingNonConcessionalCap: MemberSnapshotDimension.approachingNonConcessionalCap,
  investmentChoice: MemberSnapshotDimension.investmentChoice,
}

export enum SuperScoreMeasure {
  averageSuperScore = "SuperScore.averageSuperScore",
  averageBeneficiaryScore = "SuperScore.averageBeneficiaryScore",
  averageAccountBalanceScore = "SuperScore.averageAccountBalanceScore",
  averageInsuranceScore = "SuperScore.averageInsuranceScore",
  averageInvestmentScore = "SuperScore.averageInvestmentScore",
  averageRetirementAdequacyScore = "SuperScore.averageRetirementAdequacyScore",
  _count_NominatedBeneficiary_False = "SuperScore._count_NominatedBeneficiary_False",
  _percent_NominatedBeneficiary_False = "SuperScore._percent_NominatedBeneficiary_False",
  _count_NominatedBeneficiary_True = "SuperScore._count_NominatedBeneficiary_True",
  _percent_NominatedBeneficiary_True = "SuperScore._percent_NominatedBeneficiary_True",
  _count_BalanceWithinAverage_False = "SuperScore._count_BalanceWithinAverage_False",
  _percent_BalanceWithinAverage_False = "SuperScore._percent_BalanceWithinAverage_False",
  _count_AdequateInsuranceCover_False = "SuperScore._count_AdequateInsuranceCover_False",
  _percent_AdequateInsuranceCover_False = "SuperScore._percent_AdequateInsuranceCover_False",
  _count_SuitableInvestmentStrategy_False = "SuperScore._count_SuitableInvestmentStrategy_False",
  _percent_SuitableInvestmentStrategy_False = "SuperScore._percent_SuitableInvestmentStrategy_False",
  _count_OnTrackForRetirement_False = "SuperScore._count_OnTrackForRetirement_False",
  _percent_OnTrackForRetirement_False = "SuperScore._percent_OnTrackForRetirement_False",
  _count_AdequateRetirementStandard_False = "SuperScore._count_AdequateRetirementStandard_False",
  _percent_AdequateRetirementStandard_False = "SuperScore._percent_AdequateRetirementStandard_False",
}

export enum SuperScoreDimension {
  score = "SuperScore.score",
  _scoreNow = "SuperScore._scoreNow",
  accountBalancePoints = "SuperScore.accountBalancePoints",
  balanceWithinAverage = "SuperScore.balanceWithinAverage",
  consolidationImplemented = "SuperScore.consolidationImplemented",
  makingVoluntaryContributions = "SuperScore.makingVoluntaryContributions",
  beneficiaryPoints = "SuperScore.beneficiaryPoints",
  lifeCoverWithinBenchmark = "SuperScore.lifeCoverWithinBenchmark",
  insuranceIndicatorCompletedAndAdequate = "SuperScore.insuranceIndicatorCompletedAndAdequate",
  lifeInsuranceIndicatorResult = "SuperScore.lifeInsuranceIndicatorResult",
  insuranceAdviceImplemented = "SuperScore.insuranceAdviceImplemented",
  insurancePoints = "SuperScore.insurancePoints",
  investmentAdviceImplemented = "SuperScore.investmentAdviceImplemented",
  investmentPoints = "SuperScore.investmentPoints",
  investmentStrategySuitable = "SuperScore.investmentStrategySuitable",
  riskProfileAssessmentCompletedAndAligned = "SuperScore.riskProfileAssessmentCompletedAndAligned",
  onTrackOrOnTrackUsingTolerance = "SuperScore.onTrackOrOnTrackUsingTolerance",
  retirementAdequacyPoints = "SuperScore.retirementAdequacyPoints",
  growthExposureAdequated = "SuperScore.growthExposureAdequated",
  projectedRetirementStandardName = "SuperScore.projectedRetirementStandardName",
  consolidationVerified = "SuperScore.consolidationVerified",
}

export const SuperScoreCube = <const>{
  // Measures
  averageSuperScore: SuperScoreMeasure.averageSuperScore,
  averageBeneficiaryScore: SuperScoreMeasure.averageBeneficiaryScore,
  averageAccountBalanceScore: SuperScoreMeasure.averageAccountBalanceScore,
  averageInsuranceScore: SuperScoreMeasure.averageInsuranceScore,
  averageInvestmentScore: SuperScoreMeasure.averageInvestmentScore,
  averageRetirementAdequacyScore: SuperScoreMeasure.averageRetirementAdequacyScore,
  _count_NominatedBeneficiary_False: SuperScoreMeasure._count_NominatedBeneficiary_False,
  _percent_NominatedBeneficiary_False: SuperScoreMeasure._percent_NominatedBeneficiary_False,
  _count_NominatedBeneficiary_True: SuperScoreMeasure._count_NominatedBeneficiary_True,
  _percent_NominatedBeneficiary_True: SuperScoreMeasure._percent_NominatedBeneficiary_True,
  _count_BalanceWithinAverage_False: SuperScoreMeasure._count_BalanceWithinAverage_False,
  _percent_BalanceWithinAverage_False: SuperScoreMeasure._percent_BalanceWithinAverage_False,
  _count_AdequateInsuranceCover_False: SuperScoreMeasure._count_AdequateInsuranceCover_False,
  _percent_AdequateInsuranceCover_False: SuperScoreMeasure._percent_AdequateInsuranceCover_False,
  _count_SuitableInvestmentStrategy_False:
    SuperScoreMeasure._count_SuitableInvestmentStrategy_False,
  _percent_SuitableInvestmentStrategy_False:
    SuperScoreMeasure._percent_SuitableInvestmentStrategy_False,
  _count_OnTrackForRetirement_False: SuperScoreMeasure._count_OnTrackForRetirement_False,
  _percent_OnTrackForRetirement_False: SuperScoreMeasure._percent_OnTrackForRetirement_False,
  _count_AdequateRetirementStandard_False:
    SuperScoreMeasure._count_AdequateRetirementStandard_False,
  _percent_AdequateRetirementStandard_False:
    SuperScoreMeasure._percent_AdequateRetirementStandard_False,

  // Dimensions
  score: SuperScoreDimension.score,
  _scoreNow: SuperScoreDimension._scoreNow,
  accountBalancePoints: SuperScoreDimension.accountBalancePoints,
  balanceWithinAverage: SuperScoreDimension.balanceWithinAverage,
  consolidationImplemented: SuperScoreDimension.consolidationImplemented,
  makingVoluntaryContributions: SuperScoreDimension.makingVoluntaryContributions,
  beneficiaryPoints: SuperScoreDimension.beneficiaryPoints,
  lifeCoverWithinBenchmark: SuperScoreDimension.lifeCoverWithinBenchmark,
  insuranceIndicatorCompletedAndAdequate:
    SuperScoreDimension.insuranceIndicatorCompletedAndAdequate,
  lifeInsuranceIndicatorResult: SuperScoreDimension.lifeInsuranceIndicatorResult,
  insuranceAdviceImplemented: SuperScoreDimension.insuranceAdviceImplemented,
  insurancePoints: SuperScoreDimension.insurancePoints,
  investmentAdviceImplemented: SuperScoreDimension.investmentAdviceImplemented,
  investmentPoints: SuperScoreDimension.investmentPoints,
  investmentStrategySuitable: SuperScoreDimension.investmentStrategySuitable,
  riskProfileAssessmentCompletedAndAligned:
    SuperScoreDimension.riskProfileAssessmentCompletedAndAligned,
  onTrackOrOnTrackUsingTolerance: SuperScoreDimension.onTrackOrOnTrackUsingTolerance,
  retirementAdequacyPoints: SuperScoreDimension.retirementAdequacyPoints,
  growthExposureAdequated: SuperScoreDimension.growthExposureAdequated,
  projectedRetirementStandardName: SuperScoreDimension.projectedRetirementStandardName,
  consolidationVerified: SuperScoreDimension.consolidationVerified,
}

export enum SuperScoreComponentMeasure {
  _averagePoints = "SuperScoreComponent._averagePoints",
}

export enum SuperScoreComponentDimension {
  _type = "SuperScoreComponent._type",
}

export const SuperScoreComponentCube = <const>{
  // Measures
  _averagePoints: SuperScoreComponentMeasure._averagePoints,

  // Dimensions
  _type: SuperScoreComponentDimension._type,
}
export type Dimension =
  | AssetDimension
  | CampaignDimension
  | ContactRequestedDimension
  | EmailCampaignFunnelDimension
  | WelcomeCampaignFunnelDimension
  | MemberDimension
  | MemberCategoryDimension
  | MemberSnapshotDimension
  | SuperScoreDimension
  | SuperScoreComponentDimension

export type Measure =
  | AssetOwnedMeasure
  | CampaignMeasure
  | ContactRequestedMeasure
  | EmailCampaignFunnelMeasure
  | WelcomeCampaignFunnelMeasure
  | MemberSnapshotMeasure
  | SuperScoreMeasure
  | SuperScoreComponentMeasure

export const cubes = <const>{
  AssetCube,
  AssetOwnedCube,
  CampaignCube,
  ContactRequestedCube,
  EmailCampaignFunnelCube,
  WelcomeCampaignFunnelCube,
  MemberCube,
  MemberCategoryCube,
  MemberSnapshotCube,
  SuperScoreCube,
  SuperScoreComponentCube,
}

// TODO change script to include these
export const measures = <const>{
  Campaign: CampaignMeasure,
  ContactRequested: ContactRequestedMeasure,
  EmailCampaignFunnel: EmailCampaignFunnelMeasure,
  WelcomeCampaignFunnel: WelcomeCampaignFunnelMeasure,
  MemberSnapshot: MemberSnapshotMeasure,
  SuperScore: SuperScoreMeasure,
}

export type Measures = typeof measures
export type Cubes = typeof cubes
export type Metric = Measure
